// Tenise özgü tepkiler (28 Ekim 2026). Toplam `tebrik_sayisi` mobil uyum için korunur; tür,
// `lig_akis/{id}/tebrik/{oyuncu}.tepki` alanındadır. Türü olmayan (eski/mobil) tebrik alkış sayılır.
export const REACTION_KINDS = ['alkis', 'ates', 'top'] as const;
export type ReactionKind = typeof REACTION_KINDS[number];
export type ReactionCounts = Partial<Record<ReactionKind, number>>;

export const REACTION_EMOJI: Record<ReactionKind, string> = { alkis: '👏', ates: '🔥', top: '🎾' };

export const reactionKind = (value: unknown): ReactionKind =>
  REACTION_KINDS.includes(value as ReactionKind) ? (value as ReactionKind) : 'alkis';

export const isReactionKind = (value: unknown): value is ReactionKind =>
  REACTION_KINDS.includes(value as ReactionKind);

export function countReactions(kinds: unknown[]): ReactionCounts {
  const counts: ReactionCounts = {};
  kinds.forEach(value => {
    const kind = reactionKind(value);
    counts[kind] = (counts[kind] || 0) + 1;
  });
  return counts;
}

/** Saklanan sayılar; yoksa ya da toplamla uyuşmuyorsa eksik kısım alkış sayılır. */
export function normalizeReactionCounts(value: unknown, total: number): ReactionCounts {
  const counts: ReactionCounts = {};
  if (value && typeof value === 'object') {
    REACTION_KINDS.forEach(kind => {
      const count = Number((value as Record<string, unknown>)[kind]);
      if (Number.isInteger(count) && count > 0) counts[kind] = count;
    });
  }
  const known = REACTION_KINDS.reduce((sum, kind) => sum + (counts[kind] || 0), 0);
  if (known < total) counts.alkis = (counts.alkis || 0) + total - known;
  return counts;
}

/** En çok kullanılan türler önce (eşitlikte sabit sıra). */
export const topReactionKinds = (counts: ReactionCounts) =>
  REACTION_KINDS.filter(kind => (counts[kind] || 0) > 0).sort(
    (a, b) => (counts[b] || 0) - (counts[a] || 0),
  );
